import { render, staticRenderFns } from "./FormApplication.vue?vue&type=template&id=9c4d2bf4&scoped=true&"
import script from "./FormApplication.vue?vue&type=script&lang=js&"
export * from "./FormApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4d2bf4",
  null
  
)

export default component.exports